import { createFileRoute } from '@tanstack/react-router'
import node, {
  type graphGeneralSettingsPageQuery,
} from '#gen/relay/graphGeneralSettingsPageQuery.graphql'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/settings/graph/',
)({
  staticData: { title: '[graph] - Settings' },
  async loader({ context, params }) {
    return context.preload<graphGeneralSettingsPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/settings/graph-general-settings-page'),
    'GraphGeneralSettingsPage',
  ),
})
